























import { Component, Vue } from "vue-property-decorator";
import LoadingButton from "@/components/LoadingButton.vue";

@Component({
  components: { LoadingButton }
})
export default class EstimateTemplateModal extends Vue {
  templateName: string = "";
  status: string = "";

  show() {
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  async create() {
    this.status = "progressing";
    try {
      await new Promise<void>((resolve, reject) => {
        this.$emit("ok", this.templateName, { resolve, reject });
      });
      alert("保存しました。");
    } catch (error) {
      alert("保存に失敗しました。");
    } finally {
      this.status = "";
      this.hide();
    }
  }
}
